/**
 * Системные логи. Модуль для работы с API
 * @module systemLogs
 */

import { buildQueryParams, cleanParams } from "@/utils";

/**
 * Получение списка логов с пагинацией
 * @param {Object} params - параметры запроса
 * @returns {Promise} - данные логов
 * @throws {Error} - ошибка при получении данных
 */
export const getList = async (params, isAdmin = false) => {
  const cleanedFilters = cleanParams(params);
  const queryString = buildQueryParams(cleanedFilters);

  try {
    const response = await fetch(`/api/audit-logs${isAdmin ? '/admin' : ''}?${queryString}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
};